import { useParams } from 'react-router';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  FileText,
} from '@t90/ui';

const categoryInfo: Record<string, { title: string; description: string }> = {
  'getting-started': {
    title: 'Getting Started',
    description: 'Introduction to Turn90 and how to get started.',
  },
  operations: {
    title: 'Operations Manual',
    description: 'Procedures for daily operations, production, and quality control.',
  },
  program: {
    title: 'Program Guide',
    description: 'Information about our workforce development program.',
  },
  procedures: {
    title: 'SOPs & Procedures',
    description: 'Standard operating procedures for all departments.',
  },
  training: {
    title: 'Training Materials',
    description: 'Training guides and educational resources.',
  },
  templates: {
    title: 'Templates',
    description: 'Document templates and forms.',
  },
};

export function DocsPage() {
  const { category } = useParams<{ category?: string }>();
  
  const info = category ? categoryInfo[category] : null;

  if (!category) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Documentation</h1>
          <p className="text-muted-foreground">
            Browse Turn90's documentation by category.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          {Object.entries(categoryInfo).map(([key, value]) => (
            <Card key={key} className="hover:bg-muted/50 transition-colors">
              <CardHeader>
                <CardTitle>{value.title}</CardTitle>
                <CardDescription>{value.description}</CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>
      </div>
    );
  }

  if (!info) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <h1 className="text-2xl font-bold">Category Not Found</h1>
        <p className="text-muted-foreground">
          The documentation category you're looking for doesn't exist.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">{info.title}</h1>
        <p className="text-muted-foreground">{info.description}</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5" />
            Articles
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Documentation articles for this category will appear here.
            Content management is coming soon.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
